import httpClient from '../../client'

const getPoliticalOfficesFromCity = async (cityId) => {
  try {
    const {data} = await httpClient.get(`/cities/${cityId}/political-offices`)

    if (data) {
      return data
    }

    throw data
  } catch (error) {
    return error
  }
}

export default getPoliticalOfficesFromCity
